class Tabs {
    constructor(el) {
        this.el = el;
        this.windowRef = window.location.href
        this.provider = localStorage.getItem('single')
        
        if(this.el === void 0 || this.el === null) { return; }
        
        this.initialize()
        if(this.provider == 'artist') {
          this.setState()
        }
        this.bindEvents()
    }

    initialize() {
      this.head = this.el.querySelectorAll('.js-tab-head');
      this.content = this.el.querySelectorAll('.js-tab-content');

      for (let i = 0; i < this.content.length; i++) {
          if(!this.content[i].classList.contains('is-active')) {
              this.content[i].style.display = "none";
          }
      }
    }

    bindEvents() {
      for(let i = 0; i < this.head.length; i++) {
        this.head[i].addEventListener('click', this.onClick.bind(this));
      }
    }

    setState() {
      if (this.el.querySelector('.js-tab-head--artist')) {
        for (let i = 0; i < this.content.length; i++) {
          this.content[i].style.display = "none";
          this.head[i].classList.remove('is-active');
        }
        this.el.querySelector('.js-tab-head--artist').classList.add('is-active')
        this.el.querySelector('.js-tab-content--artist').style.display = 'block';
      }
    }

    onClick(event) {

        for (let i = 0; i < this.content.length; i++) {
            this.content[i].style.display = "none";
            this.content[i].classList.remove('is-active')
            this.head[i].classList.remove('is-active');
            this.head[i].setAttribute('aria-selected',false);
        }

        let target = event.currentTarget;
        
        this.el.querySelector('#'+target.getAttribute('aria-controls')).style.display = 'block';
        target.classList.add('is-active');
        target.setAttribute('aria-selected',true);

        if(window.sliderdefault) {
          window.sliderdefault.update()
        }
        if(window.sliderstorie) {
          window.sliderstorie.update()
        }
    }
}

export default Tabs;
